var map = {
	"./zh-cn": 784
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale ^\.\/(zh-cn)$
// module id = 783
// module chunks = 0